/**
 * "Job type prices in Excel" — a section of the Bulk price changes page (gap 1 PR 2, DEC-383,
 * D-12): every customer's job-type prices as one file, and its import. The page is for
 * MANAGE_CUSTOMER_PRICES roles only (App.tsx), so the import is always offered here; the API
 * still checks it.
 */

import React from 'react';
import type { BulkSectionProps } from '../../routes/BulkPriceChangesPage';
import { JobTypePricesExcel } from './JobTypePricesExcel';

export function JobTypeExcelSection(p: BulkSectionProps): React.JSX.Element {
  return <JobTypePricesExcel today={p.today} canEdit />;
}
